export const ErrorName = {
  NOT_LABO_USER: 'notLaboUser',
  ABORT_ERROR: 'AbortError',
  UNAUTHORIZED_ACTION: 'unauthorizedAction'
}